export default "__VITE_ASSET__dvbRsL$h__"